import Select, { Props as SelectProps, OptionsOrGroups, GroupBase, StylesConfig } from "react-select";
import React, { Fragment } from "react";
import { FormHelperText } from "@mui/material";
import { SelectErrorTheme, SelectSuccessTheme } from "./SelectTheme";
import SiteThemeProvider from "../context/SiteThemeProvider";

// Define the type for the custom styles
type CustomStyles = StylesConfig<any, false, GroupBase<any>>;

interface SelectInputBoxProps {
    name: string;
    required?: boolean;
    clear?: boolean;
    disabled?: boolean;
    add_btn?: boolean;
    onClick?: () => void;
    label?: string;
    placeholder?: string;
    value?: any;
    optionSelect: (name: string, selectedOption: any) => void;
    handleBlur?: (event: React.FocusEvent<HTMLElement>) => void;
    touched?: boolean;
    errors?: string;
    login?: boolean;
    options?: OptionsOrGroups<any, GroupBase<any>>;
}

const DefaultSelectInputBox: React.FC<SelectInputBoxProps> = ({
    name, required, login, clear, disabled, add_btn, onClick,
    label, placeholder, value, optionSelect, handleBlur,
    touched, errors, options
}) => {
    const [colorTheme] = SiteThemeProvider();

    const customStyles: StylesConfig<any, false> = {
        control: (provided, state) => ({
            ...provided,
            background: colorTheme === 'dark' ? "transparent" : '#fff',
            borderColor: "#9ca3af",
            border: state.isFocused ? "1px solid #9ca3af" : errors || (errors && touched) ? "1px solid red" : login ? "1px solid #9ca3af" : colorTheme === 'dark' ? "1px solid #0c4a6e" : "1px solid #9ca3af",
            height: "28px",
            fontWeight: 300,
            fontSize: "12px",
            fontFamily: 'Public Sans, sans-serif',
            minHeight: "28px",
            bottom: "2px",
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: "28px",
            bottom: "2px",
        }),
        input: (provided) => ({
            ...provided,
            fontSize: "12px",
            color: colorTheme === 'dark' ? 'white' : '#1e293b',
            fontWeight: 200,
            fontFamily: 'Public Sans, sans-serif',
            bottom: "2px",
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '28px',
            bottom: "2px",
        }),
        placeholder: (provided) => ({
            ...provided,
            marginTop: "0px",
            fontWeight: 300,
            fontSize: '11px',
            fontFamily: 'Public Sans, sans-serif',
            color: "#9ca3af",
            textWrap: 'nowrap',
            overflowX: "hidden",
            opacity: "1",
            userSelect: "none",
            overflow: "hidden"
        }),
        option: (provided) => ({
            ...provided,
            zIndex: 9999999999999,
            position: "sticky",
            paddingLeft: '10px',
            paddingRight: '5px',
            paddingTop: '5px',
            paddingBottom: '5px',
            fontSize: '12px',
            fontFamily: 'Public Sans, sans-serif',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: colorTheme === 'dark' ? 'white' : '#1e293b', // Set the color for the selected value
            fontFamily: 'Public Sans, sans-serif',
            fontSize: '12px',
        }),
    };
    return (
        <div className="pt-0 mt-0">
            {label && (
                <div className='flex flex-row'>
                    <label className="block text-[12px] mb-0.5 font-medium text-gray-700 dark:text-gray-200 font-public-sans" htmlFor={name}>
                        {label}
                    </label>
                    {required && <span className='text-red-500 pl-2'>*</span>}
                </div>
            )}

            {options && options.length > 0 && (
                <Select
                    placeholder={placeholder || "Select..."}
                    onChange={(selectedOption) => optionSelect(name, selectedOption)}
                    styles={customStyles}
                    value={
                        options.find(option => option.value === value?.toString())
                    }
                    theme={errors || (errors && touched) ? SelectErrorTheme : SelectSuccessTheme}
                    openMenuOnFocus
                    isSearchable
                    isDisabled={disabled}
                    options={options}
                    name={name}
                    onBlur={handleBlur}
                    className={`font-public-sans text-gray-600 font-medium text-[12px] ${errors && touched ? "text-red-600" : ""}`}
                />
            )}

            <FormHelperText>
                {errors && touched && (
                    <span className="text-red-600 font-public-sans text-[10px] font-normal">
                        {errors}
                    </span>
                )}
            </FormHelperText>
        </div>
    );
};

export default DefaultSelectInputBox;
